import { render, staticRenderFns } from "./claimStatusSelector.vue?vue&type=template&id=578c87dd&"
import script from "./claimStatusSelector.vue?vue&type=script&lang=js&"
export * from "./claimStatusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports